export const multiAddressModeDefaultConfig = {
  defaults: Object.create(null),
}

export const disabledPurposesDefaultConfig = {
  defaults: Object.create(null),
}

export const defaultConfig = {
  multiAddressMode: multiAddressModeDefaultConfig,
  disabledPurposes: disabledPurposesDefaultConfig,
}
